export default "/yt-usde.35516a4eb9433ff35217b78e72d28d17.svg";